export default __webpack_public_path__ + "static/media/01.120096e9.png";